import React from 'react';

import { shape, string } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';

import './TableBody.scss';

export default class TableBody extends BaseComponent {
  render() {
    const { style, id, className, children } = this.props;

    const classNames = ClassNames(['TableBody', className]);

    return (
      <tbody style={style} id={id} className={classNames}>
        {children}
      </tbody>
    );
  }
}

TableBody.propTypes = {
  style: shape({}),
  id: string,
  className: string
};

TableBody.defaultProps = {
  style: {},
  id: undefined,
  className: undefined
};
